// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"ProviderInfo_custom-dropdown__+xreo","item":"ProviderInfo_item__Rk-jD"};